import gql from 'graphql-tag'

export const resetPassword = gql`
  mutation resetPassword($email: String!) {
    resetPassword(email: $email ) {
      status
    }
  }
`
